import { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Seo from "@/components/Seo";
import { academyApi } from "@/lib/academy";

export default function AcademyRegister() {
  const [mode, setMode] = useState("register");
  const [form, setForm] = useState({ email: "", password: "", displayName: "" });
  const [error, setError] = useState("");
  const [done, setDone] = useState(false);
  const [busy, setBusy] = useState(false);
  const nav = useNavigate();
  const { state } = useLocation();
  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  async function submit(e) {
    e.preventDefault();
    setBusy(true);
    setError("");
    try {
      if (mode === "register") {
        await academyApi.register(form);
        setDone(true);
      } else {
        await academyApi.login({ email: form.email, password: form.password });
        nav(state?.from || "/academy/dashboard");
      }
    } catch (err) {
      setError(err.response?.data?.detail || "Something went wrong.");
    } finally {
      setBusy(false);
    }
  }

  return (
    <>
      <Seo title={mode === "register" ? "Enroll | Solar Black Belt Academy" : "Sign in | Solar Black Belt Academy"} description="Create your free Solar Black Belt Academy account — self-paced solar and Tesla Powerwall training from Coastal Energy." />
      <section className="page-hero"><div className="wrap">
        <span className="eyebrow">ACADEMY</span>
        <h1 data-testid="academy-auth-heading">{mode === "register" ? "Enroll at the academy." : "Welcome back, student."}</h1>
      </div></section>
      <section className="wrap academy-auth">
        <form onSubmit={submit} data-testid="academy-auth-form">
          {mode === "register" && (
            <label className="field"><span>Your name</span>
              <input data-testid="academy-name" value={form.displayName} onChange={set("displayName")} required minLength={2} maxLength={80} />
            </label>
          )}
          <label className="field"><span>Email</span>
            <input type="email" data-testid="academy-email" value={form.email} onChange={set("email")} required maxLength={254} />
          </label>
          <label className="field"><span>Password (8+ characters)</span>
            <input type="password" data-testid="academy-password" value={form.password} onChange={set("password")} required minLength={8} maxLength={128} />
          </label>
          {error && <p className="micro" style={{ color: "#a33" }} data-testid="academy-auth-error">{error}</p>}
          <button className="btn lime" data-testid="academy-auth-submit" disabled={busy}>
            {busy ? "One moment…" : mode === "register" ? "Create my free account" : "Sign in"}
          </button>
          <p className="micro">
            {mode === "register" ? (
              <>Already enrolled? <button type="button" className="textbutton" onClick={() => setMode("register" === mode ? "login" : "register")}>Sign in</button></>
            ) : (
              <>New here? <button type="button" className="textbutton" onClick={() => setMode("register")}>Create an account</button></>
            )}
            {" "}· Free during program setup. We confirm your email before graded exams.
          </p>
        </form>
        {done && (
          <div className="academy-exam" data-testid="academy-register-success" role="status">
            <h3>Account created</h3>
            <p>{state?.from ? "You're enrolled and signed in — your lesson is ready." : "Check your inbox for the welcome email. Lessons and practice are open right now."}</p>
            <Link className="btn small lime" to={state?.from || "/academy/dashboard"}>{state?.from ? "Back to my lesson →" : "Go to my dashboard →"}</Link>
          </div>
        )}
      </section>
    </>
  );
}
